/* eslint @typescript-eslint/no-explicit-any: 0 */

import React from 'react';

import MegaNavClothingItem from './MegaNavClothingItem';
import MegaNavItem from './MegaNavItem';

export default function MegaNav({ menu = [] }: { menu: any }) {
  return (
    <nav className="flex w-full">
      <ul className="flex w-full flex-row items-center justify-center gap-5">
        {menu.map((props: any, i: number) => (
          <React.Fragment key={props.slug}>
            {props?.content?.footwear?.title === 'Clothing' ? (
              <MegaNavClothingItem
                {...props}
                content={props.content}
                position={i + 1}
                track={true}
                pagePosition="Header"
              />
            ) : (
              <MegaNavItem
                {...props}
                content={props.content}
                position={i + 1}
                track={true}
                pagePosition="Header"
              />
            )}
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
}
